export const paystackKey = process.env.REACT_APP_PAYSTACK_KEY || '';
export const flutterwaveKey = process.env.REACT_APP_FLUTTERWAVE_KEY || '';
export const authAPIBase = process.env.REACT_APP_AUTH_API_BASE || '';
export const googleMapAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
export const googleMapID = process.env.REACT_APP_GOOGLE_MAP_ID || '';
export const marketingAPIBase = process.env.REACT_APP_MARKETING_API_BASE || '';
export const transportAPIBase = process.env.REACT_APP_TRANSPORT_API_BASE || '';
export const logisticsAPIBase = process.env.REACT_APP_LOGISTICS_API_BASE || '';
export const clientBase = process.env.REACT_APP_CLIENT_BASE || '';
export const transactionsBase =
  process.env.REACT_APP_TRANSACTIONS_API_BASE || '';
export const awsS3Bucket = process.env.REACT_APP_S3_BUCKET ?? '';
export const awsS3Region = process.env.REACT_APP_AWS_S3_REGION ?? '';
export const awsAccessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID ?? '';
export const awsSecretAccessKey =
  process.env.REACT_APP_AWS_SECRET_ACCESS_KEY ?? '';
